/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdAttachmentsAttachmentidDownloadQueryResponse,
  GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams,
  GetApiV1PersonIdAttachmentsAttachmentidDownload401,
  GetApiV1PersonIdAttachmentsAttachmentidDownload404,
  GetApiV1PersonIdAttachmentsAttachmentidDownload500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsAttachmentidDownload.ts";

function getGetApiV1PersonIdAttachmentsAttachmentidDownloadUrl(
  id: GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams["id"],
  attachmentId: GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams["attachmentId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/attachments/${attachmentId}/download` as const,
  };
  return res;
}

/**
 * @description Faz o download direto do arquivo do anexo. **(Requer Authorization para autenticação)**
 * @summary Download do anexo (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/:attachmentId/download}
 */
export async function getApiV1PersonIdAttachmentsAttachmentidDownload(
  id: GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams["id"],
  attachmentId: GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams["attachmentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdAttachmentsAttachmentidDownloadQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsAttachmentidDownload401
      | GetApiV1PersonIdAttachmentsAttachmentidDownload404
      | GetApiV1PersonIdAttachmentsAttachmentidDownload500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdAttachmentsAttachmentidDownloadUrl(
      id,
      attachmentId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
